import React from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { usePrevious } from 'hooks';
import { isDefined, notEqual } from 'utils';

type StageClickedOn = string | null;

type SetStageClickedOn = (stageClickedOn: StageClickedOn) => void;

const stageClickedOnVar = makeVar<StageClickedOn>(null);

export function useStageClickedOn(): [StageClickedOn, SetStageClickedOn] {
  const stageClickedOn = useReactiveVar(stageClickedOnVar);

  return [stageClickedOn, setStageClickedOn];
}

export function useStageClickedOnListener(callback: () => void) {
  const stageClickedOn = useReactiveVar(stageClickedOnVar);

  const previousStageClickedOn = usePrevious(stageClickedOn);

  const shouldCallCallback =
    isDefined(previousStageClickedOn) &&
    notEqual(previousStageClickedOn, stageClickedOn);

  React.useEffect(() => {
    if (shouldCallCallback) {
      callback();
    }
  }, [shouldCallCallback]);
}

export function useStageClickedOnOperations(): {
  setStageClickedOn: SetStageClickedOn;
} {
  return { setStageClickedOn };
}

function setStageClickedOn(stageClickedOn: StageClickedOn) {
  stageClickedOnVar(stageClickedOn);
}
